import { render, staticRenderFns } from "./PlaceDelete.vue?vue&type=template&id=a760f6f6&"
import script from "./PlaceDelete.vue?vue&type=script&lang=js&"
export * from "./PlaceDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports